import axios from "axios";
export const getSubdomain = () => {
  const hostname = window.location.hostname; // Get the hostname (e.g., "stage.localhost")
  const parts = hostname.split('.'); // Split it by '.'

  if (parts.length > 1) {
      return parts.slice(0, parts.length - 2).join('.');
  }
  return process.env.REACT_APP_DEFAULT_DOMAIN; 
}

export const api = axios.create({
  baseURL: process.env.REACT_APP_CMS_BACKEND_BASE_URL,
  //baseURL: "http://ec2-44-213-168-246.compute-1.amazonaws.com:8000/",
  headers: {
    hostname: getSubdomain(),
  },
});

export const getAllBlogs = async () => {
  const res = await api.get(`/resources/getAllBlogs`);
  return res;
};

export const getAllBlogsByPartner = async () => {
  const res = await api.get(`/resources/getAllBlogsByPartner`);
  return res;
};

export const getContactUs = async () => {
  const res = await api.get(`/contactUs/getAllContacts`);
  return res;
};

//home page
export const getHomeHeader = async () => {
  const res = await api.get(`/home/getAllHomeHeader`);
  return res;
};

export const getHomeSlider1 = async () => {
  const res = await api.get(`/home/getAllHomeSliderOne`);
  return res;
};

export const getHomeSlider2 = async () => {
  const res = await api.get(`/home/getAllHomeSliderTwo`);
  return res;
};

export const getHomeParagraph = async () => {
  const res = await api.get(`/home/getAllHomeParagraph`);
  return res;
};

export const getHomeOverview = async () => {
  const res = await api.get(`/home/getAllHomeService`);
  return res;
};

//buttons
export const getButton = async () => {
  const res = await api.get(`/button/getAllButton`);
  return res;
};
//buttons by partner
export const getButtonByPartner = async () => {
  const res = await api.get(`/button/getAllButtonByPartner`);
  return res;
};

// ForBusiness
export const getForBusinessCard = async () => {
  const res = await api.get(`/business/getBusinessCardById/1`);
  return res;
};
export const getForBusinessCardByPartner = async () => {
  const res = await api.get(`/business/getAllBusinessCardData`);
  return res;
};
export const getForBusinessImage = async () => {
  const res = await api.get(`/business/getBusinessHeaderById/1`);
  return res;
};
export const getForBusinessImageByPartner = async () => {
  const res = await api.get(`/business/getAllBusinessHeader`);
  return res;
};
export const getBusinessParagraph2 = async () => {
  const res = await api.get(`/business/getAllBusinessParagraph`);
  return res;
};
export const getBusinessBottom = async () => {
  const res = await api.get(`/business/getAllBusinessFooter`);
  return res;
};

// ForIndividuals
export const getForIndividualsStep = async () => {
  const res = await api.get(`/forIndividuals/getStepById/1`);
  return res;
};
export const getForIndividualsStepByPartner = async () => {
  const res = await api.get(`/forIndividuals/getAllForIndividualsStepView`);
  return res;
};
export const getForIndividualsPara = async () => {
  const res = await api.get(`/forIndividuals/getByParagraph/2`);
  return res;
};
export const getForIndividualsParaByPartner = async () => {
  const res = await api.get(`/forIndividuals/getAllForIndividualsParaView`);
  return res;
};
export const getForIndividualsComment = async () => {
  const res = await api.get(`/forIndividuals/getCommentById/1`);
  return res;
};
export const getForIndividualsCommentByPartner = async () => {
  const res = await api.get(`/forIndividuals/getAllForIndividualsCommentsView`);
  return res;
};
// About Us
export const getAboutUsHeader = async () => {
  const res = await api.get(`/abouteUsHeader/getByPartner`);
  return res;
};
export const getAboutUsParagraph = async () => {
  const res = await api.get(`/abouteUsParagraph/getByPartner`);
  return res;
};
export const getAboutUsLastTitle = async () => {
  const res = await api.get(`/abouteUsLastTittle/getById/1`);
  return res;
};
export const getAboutUsLastTitleByPartner = async () => {
  const res = await api.get(`/abouteUsLastTittle/getByPartner`);
  return res;
};
export const getAboutUsTeamSection = async () => {
  const res = await api.get(`/abouteUsTeamSectionNew/getAllTeamSection`);
  return res;
};
export const getAboutUsTeamSectionByPartner  = async () => {
  const res = await api.get(`/abouteUsTeamSectionNew/getAllTeamSectionByPartner`);
  return res;
};
export const getAboutUsStorySection = async () => {
  const res = await api.get(`/abouteUsStorySection/getByPartner`);
  return res;
};
export const getAboutUsStoryPara = async () => {
  const res = await api.get(`/abouteUsStoryPara/getByPartner`);
  return res;
};
export const getAboutUsStepCards = async () => {
  const res = await api.get(`abouteUsStepCard/getById/1`);
  return res;
};
export const getAboutUsStepCardsByPartner = async () => {
  const res = await api.get(`abouteUsStepCard/getByPartner`);
  return res;
};
export const getAboutUsOurMisson = async () => {
  const res = await api.get(`/abouteUsMission/getAll`);
  return res;
};
export const getAboutUsOurMissonByPartner = async () => {
  const res = await api.get(`/abouteUsMission/getAllByPartner`);
  return res;
};
export const getAboutUsTeamParagraph = async () => {
  const res = await api.get(`/abouteUsTeamSection/getAllTeamParagraph`);
  return res;
};
export const getAboutUsTeamParagraphByPartner = async () => {
  const res = await api.get(`/abouteUsTeamSection/getAllTeamParagraphByPartner`);
  return res;
};
//footer
export const getFooter = async () => {
  const res = await api.get(`/footer/getFooterById/7`);
  return res;
};
//footer by partner
export const getFooterByPartner = async () => {
  const res = await api.get(`/footer/getFooterByPartner`);
  return res;
};

//vrify admin account
export const verifyAdminAccount = async (token) => {
  const res = await api.get(`/admin/VerifyAccount?token=${token}`);
  return res;
};

//send contact form to admin
export const sendContactUsForm = async (data) => {
  const res = await api.post(`/contactUs/sendContactFormEmail`, data);
  return res;
};
//theme
export const setThemeSetting = async () => {
  const res = await api.get(`/partner/getDomainContent`);
  return res;
};

export const getCategoryDocument = async () => await api.get("/category/get-all-category");